
<b-modal ref="similar_products_modal"
         size="xl"
         centered
         hide-footer
         no-close-on-backdrop
         no-close-on-esc
         title="Similar Non-BTO Products Available">
  <div class="mb-3">
    <p class="text-info">
      We found similar EZBuy SKUs that might meet your requirements.
      You can add these products directly instead of configuring a custom BTO product.
    </p>
  </div>

  <div v-if="currentConfigurationDescription" class="mb-3">
    <div class="text-muted"><strong>Your Current BTO Configuration:</strong></div>
    <div class="text-muted">{{ currentConfigurationDescription }}</div>
  </div>

  <b-table striped
           hover
           :items="similarProducts"
           :fields="fields"
           show-empty
           empty-text="No similar products found">
    <template v-slot:cell(description)="data">
      <div>
        <div class="font-weight-bold">{{ data.item.description }}</div>
        <div v-if="data.item.matching_kiosk_codes" class="text-muted small mt-1">
          <strong>Matching components:</strong>
          <ul class="mb-0 mt-1">
            <li v-for="component in getMatchingComponentDescriptions(data.item.matching_kiosk_codes)" :key="component">
              {{ component }}
            </li>
          </ul>
        </div>
      </div>
    </template>
    <template v-slot:cell(actions)="data">
      <b-button variant="primary"
                size="sm"
                @click="addSimilarProduct(data.item)">
        Add To Quote
      </b-button>
    </template>
    <template v-slot:cell(price)="data">
      {{ formatCurrency(data.item.price) }}
    </template>
  </b-table>

  <div class="mt-3 d-flex justify-content-between">
    <b-button variant="outline-secondary" @click="proceedWithBTO">
      Continue with BTO Configuration
    </b-button>
    <b-button variant="secondary" @click="cancel">
      Cancel
    </b-button>
  </div>
</b-modal>
